import React from 'react'
import { CardBody, CardContainer, CardItem } from "../ui/Card_3d";
import { Section5Data } from '../../constants';
import { useStateContext } from '../../context/ContextProvider';
import {Link} from "react-router-dom"

export function ThreeDCard({card}) {
    const {currentLang}=useStateContext()
  return (
    <CardContainer className="inter-var">
      <CardBody
        className=" bg-gradient-to-br from-light-glass1 via-light-glass2 to-light-glass2 dark:from-dark-glass1 dark:via-dark-glass2 dark:to-dark-glass2 border border-light-glassStrock2 dark:border-dark-glassStrock1 relative  backdrop-blur-xl  group/card  dark:hover:shadow-2xl hover:shadow-2xl hover:shadow-blue-500/[0.1] dark:hover:shadow-blue-500/[0.1]    min-w-[96] min-h-96 h-auto rounded-xl p-4   ">
     
        <CardItem translateZ={150}    translateX={5}   className="w-full">
          <img
            src={card.image}
            height="1000"
            width="1000"
            className="h-80 w-full object-cover rounded-xl group-hover/card:shadow-xl"
            alt="thumbnail" />
        </CardItem>
        <CardItem
   translateZ={50}
   translateX={5}
          className="mt-3 h6 text-light-title dark:text-dark-title">
{currentLang==="ar"?card.title_Ar:card.title_En}
        </CardItem>
        <CardItem
          as="p"
          translateZ={40}
            translateX={5}
          className="body-2 text-light-subtitle dark:text-dark-subtitle">
       {currentLang === "ar" ?card.subtitle_Ar : card.subtitle_En}
        </CardItem>
      </CardBody>
    </CardContainer>
  );
}

const Section5Home = () => {
    const {currentLang}=useStateContext()
  return (  
    <section className='mt-12  md:mt-16 lg:mt-20 container'>
        
        <div className="mb-2">
            <h2 className="h3 text-light-blue dark:text-dark-title">
                {currentLang === "ar" ? Section5Data.title_Ar : Section5Data.title_En}
            </h2>
            <p className="h6 text-light-subtitle dark:text-dark-subtitle ">
                {currentLang === "ar" ? Section5Data.subtitle_Ar : Section5Data.subtitle_En}
            </p>
        </div>
        
      

        <div className="w-full flex flex-wrap items-center justify-center gap-x-4">
            {Section5Data.cards.map((card) => (
              <Link to={card.path}
              onClick={() => {
                window.scrollTo(0, 0);
              }}
              >  <ThreeDCard key={card.id} card={card} /></Link>
            ))}
        </div>

       
   </section>
 
  )
}


export default Section5Home